// assets/bb-home-depoimentos.js
// Comportamento dos dois carrosséis de depoimento (Lote 5, item 5.4):
//   [data-bb-depoimentos="video"] -- sections/rgd-review-carousel.liquid ("Depoimentos em vídeo"):
//     dots próprios, preview/play/volume dos vídeos, avanço quando o vídeo termina;
//   [data-bb-depoimentos="texto"] -- sections/rgd-reviews-carousel.liquid ("Depoimentos em texto"):
//     no máximo 3 dots, distribuídos pelo curso do carrossel.
// Nenhuma seção instancia Swiper: a instância chega pelo evento 'bb:swiper' que
// assets/bb-swiper.js dispara. Os corpos abaixo são os <script> inline das duas seções,
// copiados sem reescrever: a seção e a instância viram parâmetros, e o que era Liquid
// interpolado virou data- na tag da seção (data-autoplay), seletor de classe (a paginação
// do carrossel de texto) ou foi para o data-swiper-config (speed, breakpoints, navegação).
// A repetição dos slides do carrossel de vídeo (loop com poucos slides) não mora aqui: é o
// <script> inline da seção, que precisa rodar antes de qualquer bb-swiper.js.
(function () {
  // As duas seções carregam este arquivo: um <script src> roda uma vez por tag, não uma
  // vez por página. Sem a guarda, cada carrossel seria montado duas vezes.
  if (window.bbDepoimentos) return;
  window.bbDepoimentos = true;

  function montarVideo(section, reviewSwiper) {
    const autoplayEnabled = section.dataset.autoplay === 'true';

    /* ======================================================
       PAGINAÇÃO
    ====================================================== */

    const pagination = section.querySelector('.swiper-pagination');

    const realReviewsCount = pagination
      ? Number(pagination.dataset.reviewsCount)
      : 0;

    if (pagination && realReviewsCount > 1) {
      pagination.innerHTML = '';

      for (let i = 0; i < realReviewsCount; i++) {
        const dot = document.createElement('button');

        dot.type = 'button';
        dot.className = 'swiper-pagination-bullet';

        dot.setAttribute(
          'aria-label',
          'Ir para o review ' + (i + 1)
        );

        dot.addEventListener('click', function () {
          reviewSwiper.slideToLoop(i);
        });

        pagination.appendChild(dot);
      }

      function updateReviewDots() {
        const activeIndex =
          reviewSwiper.realIndex % realReviewsCount;

        const dots = pagination.querySelectorAll(
          '.swiper-pagination-bullet'
        );

        dots.forEach(function (dot, index) {
          dot.classList.toggle(
            'swiper-pagination-bullet-active',
            index === activeIndex
          );
        });
      }

      reviewSwiper.on('slideChange', updateReviewDots);

      updateReviewDots();
    }


    /* ======================================================
       HELPERS
    ====================================================== */

    function getMainVideo(wrapper) {
      if (!wrapper) return null;

      return wrapper.querySelector(
        '.rgd-review-card__video'
      );
    }


    function getPreviewVideo(wrapper) {
      if (!wrapper) return null;

      return wrapper.querySelector(
        '.rgd-review-card__preview-video'
      );
    }


    function getPlayButton(wrapper) {
      if (!wrapper) return null;

      return wrapper.querySelector(
        '.rgd-review-card__video-button'
      );
    }


    function getVolumeButton(wrapper) {
      if (!wrapper) return null;

      return wrapper.querySelector(
        '.rgd-review-card__volume-button'
      );
    }


    function prepareMutedVideo(video) {
      if (!video) return;

      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;

      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
    }


    /* ======================================================
       CONTROLE DA BOLINHA / PLAY
    ====================================================== */

    function hidePlayButton(wrapper) {
      if (!wrapper) return;

      const playButton = getPlayButton(wrapper);

      wrapper.classList.add('is-playing');

      if (playButton) {
        playButton.style.setProperty(
          'display',
          'none',
          'important'
        );

        playButton.style.setProperty(
          'opacity',
          '0',
          'important'
        );

        playButton.style.setProperty(
          'visibility',
          'hidden',
          'important'
        );

        playButton.style.setProperty(
          'pointer-events',
          'none',
          'important'
        );

        playButton.setAttribute(
          'aria-label',
          'Pausar vídeo'
        );
      }
    }


    function showPlayButton(wrapper) {
      if (!wrapper) return;

      const playButton = getPlayButton(wrapper);

      wrapper.classList.remove('is-playing');

      if (playButton) {
        playButton.style.removeProperty('display');
        playButton.style.removeProperty('opacity');
        playButton.style.removeProperty('visibility');
        playButton.style.removeProperty('pointer-events');

        playButton.setAttribute(
          'aria-label',
          'Reproduzir vídeo'
        );
      }
    }


    /* ======================================================
       VOLUME
    ====================================================== */

    function setMutedState(wrapper, isMuted) {
      if (!wrapper) return;

      const volumeButton = getVolumeButton(wrapper);

      wrapper.classList.toggle(
        'is-muted',
        isMuted
      );

      if (volumeButton) {
        volumeButton.setAttribute(
          'aria-label',
          isMuted
            ? 'Ativar som'
            : 'Mutar vídeo'
        );
      }
    }


    /* ======================================================
       RESET
    ====================================================== */

    function resetWrapper(wrapper) {
      if (!wrapper) return;

      const mainVideo = getMainVideo(wrapper);
      const previewVideo = getPreviewVideo(wrapper);

      if (mainVideo) {
        mainVideo.pause();
        mainVideo.muted = true;

        try {
          mainVideo.currentTime = 0;
        } catch (error) {}
      }

      if (previewVideo) {
        previewVideo.pause();
        previewVideo.muted = true;

        try {
          previewVideo.currentTime = 0;
        } catch (error) {}
      }

      wrapper.classList.remove(
        'is-main-active'
      );

      showPlayButton(wrapper);

      setMutedState(
        wrapper,
        true
      );
    }


    function resetAllWrappers(exceptionWrapper = null) {
      section
        .querySelectorAll(
          '.rgd-review-card__video-wrapper'
        )
        .forEach(function (wrapper) {

          if (wrapper === exceptionWrapper) {
            return;
          }

          resetWrapper(wrapper);
        });
    }


    /* ======================================================
       PREVIEW AUTOMÁTICO
    ====================================================== */

    function playPreview(wrapper) {
      if (!wrapper) return false;

      const previewVideo = getPreviewVideo(wrapper);
      const mainVideo = getMainVideo(wrapper);

      if (!previewVideo) {
        return false;
      }

      /*
        Estamos no preview.
        Principal ainda não assumiu o card.
      */
      wrapper.classList.remove(
        'is-main-active'
      );

      setMutedState(
        wrapper,
        true
      );

      /*
        Primeiro paramos o principal.
      */
      if (mainVideo) {
        mainVideo.pause();
        mainVideo.muted = true;

        try {
          mainVideo.currentTime = 0;
        } catch (error) {}
      }

      prepareMutedVideo(
        previewVideo
      );

      previewVideo.loop = true;
      previewVideo.muted = true;

      try {
        previewVideo.currentTime = 0;
      } catch (error) {}


      /*
        Autoplay desligado:
        fica parado com botão de play.
      */
      if (!autoplayEnabled) {
        showPlayButton(wrapper);

        return true;
      }


      /*
        Já escondemos imediatamente.

        Assim nem existe aquele flash da
        bolinha enquanto .play() resolve.
      */
      hidePlayButton(wrapper);


      const playPromise =
        previewVideo.play();


      if (playPromise !== undefined) {
        playPromise
          .then(function () {

            /*
              Preview realmente começou.
              Mantém a bolinha escondida.
            */
            hidePlayButton(wrapper);

          })
          .catch(function () {

            /*
              Se o navegador bloquear autoplay,
              aí mostramos o botão.
            */
            showPlayButton(wrapper);

          });
      }

      return true;
    }


    /* ======================================================
       PLAY DO VÍDEO PRINCIPAL
    ====================================================== */

    function playMainVideo(
      wrapper,
      restart = false
    ) {
      if (!wrapper) return;

      const mainVideo = getMainVideo(wrapper);
      const previewVideo = getPreviewVideo(wrapper);

      if (!mainVideo) return;


      /*
        Para todos os outros cards.
      */
      resetAllWrappers(
        wrapper
      );


      /*
        Para preview atual.
      */
      if (previewVideo) {
        previewVideo.pause();

        try {
          previewVideo.currentTime = 0;
        } catch (error) {}
      }


      /*
        Principal assume o card.
      */
      wrapper.classList.add(
        'is-main-active'
      );


      if (restart) {
        try {
          mainVideo.currentTime = 0;
        } catch (error) {}
      }


      /*
        Esconde imediatamente para não
        aparecer bolinha durante carregamento.
      */
      hidePlayButton(wrapper);


      const playPromise =
        mainVideo.play();


      if (playPromise !== undefined) {
        playPromise
          .then(function () {

            hidePlayButton(wrapper);

          })
          .catch(function () {

            showPlayButton(wrapper);

          });
      }
    }


    /* ======================================================
       PAUSE PRINCIPAL
    ====================================================== */

    function pauseMainVideo(wrapper) {
      if (!wrapper) return;

      const mainVideo =
        getMainVideo(wrapper);

      if (!mainVideo) return;

      mainVideo.pause();

      /*
        Usuário pausou o principal.

        AGORA SIM mostramos a bolinha.
      */
      showPlayButton(wrapper);
    }


    /* ======================================================
       TOGGLE
    ====================================================== */

    function toggleMainVideo(wrapper) {
      if (!wrapper) return;

      const mainVideo = getMainVideo(wrapper);
      const previewVideo = getPreviewVideo(wrapper);

      if (!mainVideo) return;


      /*
        Ainda está vendo preview.

        Clique = inicia principal.
      */
      if (
        previewVideo &&
        !wrapper.classList.contains(
          'is-main-active'
        )
      ) {
        playMainVideo(
          wrapper,
          true
        );

        return;
      }


      /*
        Principal já assumiu o card.
      */
      if (mainVideo.paused) {
        playMainVideo(
          wrapper,
          false
        );
      } else {
        pauseMainVideo(
          wrapper
        );
      }
    }


    /* ======================================================
       SLIDE ATIVO
    ====================================================== */

    function playActiveMedia() {
      const activeSlide = section.querySelector(
        '.swiper-slide-active'
      );

      if (!activeSlide) return;

      const wrapper = activeSlide.querySelector(
        '.rgd-review-card__video-wrapper'
      );

      if (!wrapper) return;


      resetAllWrappers(
        wrapper
      );


      const previewVideo =
        getPreviewVideo(wrapper);

      const mainVideo =
        getMainVideo(wrapper);


      /* ==========================================
         TEM PREVIEW
      ========================================== */

      if (previewVideo) {
        playPreview(
          wrapper
        );

        return;
      }


      /* ==========================================
         NÃO TEM PREVIEW

         Principal faz autoplay.
      ========================================== */

      if (
        mainVideo &&
        autoplayEnabled
      ) {
        prepareMutedVideo(
          mainVideo
        );

        mainVideo.muted = true;

        wrapper.classList.add(
          'is-main-active'
        );

        setMutedState(
          wrapper,
          true
        );


        /*
          Esconde antes mesmo do play.
        */
        hidePlayButton(wrapper);


        const playPromise =
          mainVideo.play();


        if (playPromise !== undefined) {
          playPromise
            .then(function () {

              hidePlayButton(wrapper);

            })
            .catch(function () {

              showPlayButton(wrapper);

            });
        }
      } else {

        /*
          Sem autoplay:
          botão fica disponível.
        */
        showPlayButton(wrapper);
      }
    }


    /* ======================================================
       CONFIGURAÇÃO DOS CARDS
    ====================================================== */

    section
      .querySelectorAll(
        '.rgd-review-card__video-wrapper'
      )
      .forEach(function (wrapper) {

        const mainVideo =
          getMainVideo(wrapper);

        const previewVideo =
          getPreviewVideo(wrapper);

        const playButton =
          getPlayButton(wrapper);

        const volumeButton =
          getVolumeButton(wrapper);


        if (!mainVideo) return;


        /* ======================================
           MAIN
        ====================================== */

        prepareMutedVideo(
          mainVideo
        );

        mainVideo.muted = true;

        setMutedState(
          wrapper,
          true
        );


        /* ======================================
           PREVIEW
        ====================================== */

        if (previewVideo) {
          prepareMutedVideo(
            previewVideo
          );

          previewVideo.loop = true;
          previewVideo.muted = true;


          /*
            PREVIEW COMEÇOU

            Sempre esconde a bolinha.
          */
          previewVideo.addEventListener(
            'play',
            function () {

              if (
                !wrapper.classList.contains(
                  'is-main-active'
                )
              ) {
                hidePlayButton(
                  wrapper
                );
              }

            }
          );


          /*
            PREVIEW PAUSOU

            Só mostramos a bolinha se
            NÃO estivermos entrando no main.

            Isso impede conflito na troca
            preview → vídeo completo.
          */
          previewVideo.addEventListener(
            'pause',
            function () {

              if (
                wrapper.classList.contains(
                  'is-main-active'
                )
              ) {
                return;
              }


              /*
                Se o slide ainda estiver ativo
                mas foi uma pausa inesperada,
                aí mostramos play.
              */
              const slide = wrapper.closest(
                '.swiper-slide'
              );

              if (
                slide &&
                slide.classList.contains(
                  'swiper-slide-active'
                ) &&
                !reviewSwiper.animating
              ) {
                showPlayButton(
                  wrapper
                );
              }

            }
          );
        }


        /* ======================================
           BOTÃO CENTRAL
        ====================================== */

        if (playButton) {
          playButton.addEventListener(
            'click',
            function (event) {

              event.preventDefault();
              event.stopPropagation();

              toggleMainVideo(
                wrapper
              );
            }
          );
        }


        /* ======================================
           CLIQUE NA ÁREA DO VÍDEO
        ====================================== */

        wrapper.addEventListener(
          'click',
          function (event) {

            /*
              Botões têm lógica própria.
            */
            if (
              event.target.closest(
                '.rgd-review-card__volume-button'
              ) ||
              event.target.closest(
                '.rgd-review-card__video-button'
              )
            ) {
              return;
            }


            /*
              Só o slide central recebe clique.
            */
            const slide = wrapper.closest(
              '.swiper-slide'
            );

            if (
              slide &&
              !slide.classList.contains(
                'swiper-slide-active'
              )
            ) {
              return;
            }


            toggleMainVideo(
              wrapper
            );
          }
        );


        /* ======================================
           VOLUME
        ====================================== */

        if (volumeButton) {
          volumeButton.addEventListener(
            'click',
            function (event) {

              event.preventDefault();
              event.stopPropagation();


              /*
                Preview não pode ativar áudio.
              */
              if (
                !wrapper.classList.contains(
                  'is-main-active'
                )
              ) {
                return;
              }


              const newMutedState =
                !mainVideo.muted;


              /*
                Ativando som:
                muta todos os demais.
              */
              if (!newMutedState) {
                section
                  .querySelectorAll(
                    '.rgd-review-card__video'
                  )
                  .forEach(function (
                    otherVideo
                  ) {

                    if (
                      otherVideo ===
                      mainVideo
                    ) {
                      return;
                    }

                    otherVideo.muted = true;


                    const otherWrapper =
                      otherVideo.closest(
                        '.rgd-review-card__video-wrapper'
                      );


                    if (otherWrapper) {
                      setMutedState(
                        otherWrapper,
                        true
                      );
                    }
                  });
              }


              mainVideo.muted =
                newMutedState;


              setMutedState(
                wrapper,
                mainVideo.muted
              );
            }
          );
        }


        /* ======================================
           MAIN PLAY
        ====================================== */

        mainVideo.addEventListener(
          'play',
          function () {

            wrapper.classList.add(
              'is-main-active'
            );

            hidePlayButton(
              wrapper
            );
          }
        );


        /* ======================================
           MAIN PAUSE
        ====================================== */

        mainVideo.addEventListener(
          'pause',
          function () {

            const previewVideo =
              getPreviewVideo(wrapper);


            /*
              IMPORTANTE:

              Se estamos ainda no modo preview
              e o preview está rodando, o pause
              do main NÃO pode mostrar a bolinha.
            */
            if (
              !wrapper.classList.contains(
                'is-main-active'
              ) &&
              previewVideo &&
              !previewVideo.paused
            ) {
              hidePlayButton(
                wrapper
              );

              return;
            }


            /*
              Se o MAIN está ativo e pausou,
              mostra o play.
            */
            if (
              wrapper.classList.contains(
                'is-main-active'
              )
            ) {
              showPlayButton(
                wrapper
              );
            }
          }
        );


        /* ======================================
           MAIN TERMINOU
        ====================================== */

        mainVideo.addEventListener(
          'ended',
          function () {

            showPlayButton(
              wrapper
            );


            /*
              Apenas o principal
              avança o carousel.
            */
            reviewSwiper.slideNext();
          }
        );
      });


    /* ======================================================
       SWIPER EVENTS
    ====================================================== */

    reviewSwiper.on(
      'slideChangeTransitionStart',
      function () {

        resetAllWrappers();

      }
    );


    reviewSwiper.on(
      'slideChangeTransitionEnd',
      function () {

        playActiveMedia();

      }
    );


    /* ======================================================
       PRIMEIRO SLIDE

       Lote 8 (17/09): era setTimeout de 300 ms, ou seja, o primeiro vídeo começava a
       tocar com o carrossel a milhares de pixels da dobra — e o preload='metadata' dos
       clones do loop fazia o mesmo vídeo baixar 3 a 4 vezes (9,5 MB na PDP sem ninguém
       pedir). Agora o play nasce quando a seção entra na tela.
       Prova: e2e/depoimentos-peso.spec.ts.
    ====================================================== */

    if ('IntersectionObserver' in window) {

      const observador = new IntersectionObserver(
        function (entradas) {

          if (!entradas.some(function (e) { return e.isIntersecting; })) return;

          observador.disconnect();

          playActiveMedia();

        },
        { rootMargin: '200px' }
      );

      observador.observe(section);

    } else {

      setTimeout(
        function () {

          playActiveMedia();

        },
        300
      );
    }
  }

  function montarTexto(section, swiper) {
    const paginationEl = section.querySelector('.rgd-reviews-pagination');

    const getSlidesPerView = () => {
      const current = swiper.params.slidesPerView;
      if (current === 'auto') return 1;
      return Number(current) || 1;
    };

    const getMaxIndex = () => {
      const totalSlides = swiper.slides.length;
      const perView = getSlidesPerView();
      return Math.max(0, Math.ceil(totalSlides - perView));
    };

    const createLimitedDots = () => {
      if (!paginationEl) return;

      const maxIndex = getMaxIndex();
      const dotsCount = Math.min(3, maxIndex + 1);

      paginationEl.innerHTML = '';

      if (dotsCount <= 1) {
        paginationEl.style.display = 'none';
        return;
      }

      paginationEl.style.display = 'flex';

      for (let i = 0; i < dotsCount; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'rgd-review-dot';

        dot.addEventListener('click', () => {
          const targetIndex = dotsCount <= 1 ? 0 : Math.round((i / (dotsCount - 1)) * maxIndex);
          swiper.slideTo(targetIndex);
        });

        paginationEl.appendChild(dot);
      }
    };

    const updateLimitedDots = () => {
      if (!paginationEl) return;

      const dots = paginationEl.querySelectorAll('.rgd-review-dot');
      if (!dots.length) return;

      const maxIndex = getMaxIndex();
      const activeIndex = Math.min(swiper.activeIndex, maxIndex);

      const activeDot = maxIndex === 0
        ? 0
        : Math.round((activeIndex / maxIndex) * (dots.length - 1));

      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activeDot);
      });
    };

    createLimitedDots();
    updateLimitedDots();

    swiper.on('slideChange', () => {
      updateLimitedDots();
    });

    swiper.on('resize', () => {
      swiper.update();
      createLimitedDots();
      updateLimitedDots();
    });

    setTimeout(() => {
      swiper.update();
      swiper.slideTo(0, 0, false);
      createLimitedDots();
      updateLimitedDots();
    }, 150);
  }

  function montar(el, swiper) {
    const section = el.closest('[data-bb-depoimentos]');
    if (!section) return;
    if (section.dataset.bbDepoimentos === 'video') montarVideo(section, swiper);
    if (section.dataset.bbDepoimentos === 'texto') montarTexto(section, swiper);
  }

  document.addEventListener('bb:swiper', function (e) {
    montar(e.target, e.detail.swiper);
  });

  // Outra seção acima na página pode ter carregado assets/bb-swiper.js antes deste arquivo
  // (o hero da home carrega): scripts defer rodam em ordem de documento, e o primeiro
  // bb-swiper.js varre o documento inteiro. Nesse caso o 'bb:swiper' destes carrosséis já
  // disparou sem ouvinte, e a instância é pega pela marca de pronto.
  document.querySelectorAll('[data-bb-depoimentos] .swiper[data-bb-swiper="pronto"]').forEach(function (el) {
    montar(el, el.swiper);
  });
})();
